<script>
var jj = "//smartcity1.mapjiangyin.com/KMap/rest/services/jyjj/MapServer";
var mapextend = "120.78,31.08,121.17,31.56";

var centerX = 120.316429;
var centerY = 31.835289;
var sheetNumber = "苏B(2025)026号-甲测资字32100598";
var DL =
  "餐饮;住宿;地名地址;公共设施;公司企业;交通运输、仓储;教育、文化;金融、保险;居民服务;批发、零售;汽车销售及服务;卫生、社保;运动、休闲";

var yx_array = ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"];
var mapurl = "//smartcity1.mapjiangyin.com/KMap/rest/services/";

var sldt_jy =
  "//smartcity1.mapjiangyin.com/KMap/rest/services/jysl/MapServer";

var yxdt_jy =
  "//smartcity1.mapjiangyin.com/KMap/rest/services/jyyx/MapServer";
var yxzj_jy =
  "//smartcity1.mapjiangyin.com/KMap/rest/services/jyyxzj/MapServer";
var poi_jy =
  "//smartcity1.mapjiangyin.com/KMap/rest/services/JYTDT/MapServer";
var jyRespl =
  "//smartcity1.mapjiangyin.com/KMap/rest/services/jyRespl/MapServer";
var jysd =
  "//smartcity1.mapjiangyin.com/KMap/rest/services/jysd/MapServer";
var url =
  "//smartcity1.mapjiangyin.com/Token/RemoteTokenServerWithoutPwd?gispwd=GisToken";
var tk = "";
$.ajax({
  type: "get",
  async: false,
  contentType: "application/json",
  url: url,
  success: function (data) {
    tk = data.data; //全局可使用
  },
  error: function (err) {
    console.log(err);
  },
});
export default {
  jj,
  DL,
  mapextend,
  centerX,
  centerY,
  sheetNumber,
  sldt_jy,
  yxdt_jy,
  yxzj_jy,
  poi_jy,
  jyRespl,
  jysd,
  yx_array,
  mapurl,
  tk
};
</script>
